import { Controller } from "stimulus"

export default class extends Controller {

  static targets = ["project_id", "skill_id", "po_rate_regular", "po_rate_overtime"]

    suggest() {

      if (this.project_idTarget.value === "" || this.skill_idTarget.value === "" ){
        return false;
      }
      const url = this.data.get("url")+ "?project_id=" + this.project_idTarget.value + "&skill_id=" + this.skill_idTarget.value;
      const po_rate_regular_field = this.po_rate_regularTarget
      const po_rate_overtime_field = this.po_rate_overtimeTarget
      
      $.get(url, function (data) {
        const value = data[0].modal_value
        // if(value !== null){
          po_rate_regular_field.value = value
          po_rate_overtime_field.value = value
        // }
     
      });
        
    }

    

}